<script>
    const bitCoin = 'assets/blog/bitCoin.png';
    const crypto = 'assets/blog/crypto.png';
    const elonMusk = 'assets/blog/elonMusk.png';
    const arrowDown = 'assets/arrowDown.svg';

    const blogsData = [
        {   
            img: bitCoin, 
            header: 'Yes, bitcoin could be the new GameStop', 
            subHeader: 'Feb 01, 2021 • MacKenzie Sigalos',
            link: 'https://www.cnbc.com/2021/02/01/how-bitcoin-could-be-the-new-gamestop.html?recirc=taboolainternal'
        },
        {   
            img: crypto, 
            header: 'Elon Musk’s tweets are moving markets — and some investors are worried', 
            subHeader: 'Jan 29, 2021 • Sam Shead',
            link: 'https://www.cnbc.com/2021/01/29/elon-musks-tweets-are-moving-markets.html?recirc=taboolainternal'
        },
        {   
            img: elonMusk, 
            header: 'Soon you will buy, send and spend your crypto with NIOapp', 
            subHeader: 'Jan 28, 2021 • NIO team',
            link: ''
        }
    ]

    let faqData = [
          { header: 'What is NIO platform?', active: true, youTube: 'https://www.youtube.com/embed/mZ8N24fDW4c'}, 
          { header: 'How to onboard on NIO?', active: false, youTube: 'https://www.youtube.com/embed/IMIfWyjDFOI' }, 
          { header: 'How to top-up NIO account?', active: false, youTube: 'https://www.youtube.com/embed/nq2UoE17QRI'}, 
          { header: 'How to order NIO debit card?', active: false, youTube: 'https://www.youtube.com/embed/LNlz6wCbZSg'}, 
          { header: 'How to order and use IBAN?', active: false, youTube: '    https://www.youtube.com/embed/iiTpO7CZPvo'}, 
          { header: 'Applying for NIO business account', active: false, youTube: 'https://www.youtube.com/embed/HPPnmCETslw'}, 
    ]

    const expand = (section) => {
		faqData = faqData.map(s => {
			if (s.header === section.header) {
				s.active = !s.active 
			}else{
                s.active = false
            }
			return s
		})
	}

    const linktToExternalSite = (site) => window.location.href = site;

</script>


<div class="container" id='blog'>
    <div class="ourBlogContainer">
        <div class="ourBlog">
            <div class="blogHeader ourBlogHeader">Our blog</div>
                {#each blogsData as blog }
                    <div class="blog" on:click={() => linktToExternalSite(blog.link)}>
                            <img class='blogImage' src={blog.img} alt='bitCoin'/>
                            <div class="image"></div>
                            <div class="paragrafs">
                                <div class="paragrafHeader">{blog.header}</div>
                                <div class="paragrafSubHeader">{blog.subHeader}</div>
                            </div>
                    </div>
                {/each}
            </div>
        <div class="faq">
            <div class="blogHeader">FAQ</div>
            <div>
                {#each faqData as faq }
                    <div class='faqCollapse' >
                        <div class='faqCollapseFront' on:click={() => expand(faq)}>
                            <div class='faqCollapseHeader'>{faq.header} </div>
                            <img class='{faq.active ? 'faqCollapseArrowUp' : 'faqCollapseArrowDown'}' src={arrowDown} alt='arrowDown'/>
                        </div>
                        <div class={faq.active ? 'showCollapse': 'hideCollapse'}>
                            <iframe class="youtubeVideo" width="265" height="148" src={faq.youTube} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title=''></iframe>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>  
</div>


<style>

    .container{
        background-color: #F6F6F6;
        padding: 0 30px 50px 30px;
     }

     .ourBlogContainer{
        max-width: 1170px;
        margin: 0 auto;
        padding-top: 50px;
     }

     .blogHeader{
        font-size: 32px;
        letter-spacing: -1px;
        line-height: 36px;
        text-align: left;
     }

     .ourBlogContainer {
        display: flex;
        justify-content: space-between;
     }

     .blog{
        display: flex;
        margin-top: 10px;
        cursor: pointer;
        padding: 10px 0px 10px 10px;
        border-radius: 10px;
     }

     .blog:hover{
         background-color: #fdfdfd;
     }
     .blog:hover .paragrafHeader{
         text-decoration: underline;
     }
     .blog:hover .blogImage{
         opacity: 0.5;
     }

     .ourBlog{
         flex: 1;
         padding-right: 20px;
     }

     .ourBlogHeader{
         margin-left: 10px;
     }

     .faq{
         flex: 1
     }

     .blogImage{
         width: 200px;
         height: 112px;
         margin-right: 20px;
     }

     .paragrafHeader{
        font-size: 18px;
        line-height: 24px;
        text-align: left;
        font-weight: 600;
        margin-bottom: 20px;
        color: #000;
     }

     .faqCollapse{
        border-bottom: 1px solid #dddddd;
     }

     .faqCollapseFront{
        display: flex;
        justify-content: space-between;
        height: 60px;
        align-items: center;
        cursor: pointer;

     }

     .faqCollapseArrowUp{
        transform: rotate(180deg);
     }

     .showCollapse{
        display: block;
     }

     .hideCollapse{
        display: none;
     }

     .youtubeVideo{
         margin-bottom: 30px;
     }



     @media (max-width: 769px) { 

        .ourBlogContainer {
            flex-direction: column;
        }

        .blogImage {
            width: 96px;
            height: 54px;
        }

        .paragrafHeader {
            font-size: 16px;
        }

        .paragrafSubHeader{
            font-size: 14px;
        }
    

      }

</style>